<p-floatlabel class="w-full flex-1 block" [formGroup]="formGroup">
  <p-datepicker [inputId]="id" styleClass="w-full" [touchUI]="touchUI" [formControlName]="id"
  [maxDate]="maxDate" [minDate]="minDate"></p-datepicker>
  <label [for]="id">{{label}}</label>
</p-floatlabel>

@if (formError) {
  <app-form-error [message]="formError"></app-form-error>
}
